<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Lista ustawień</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-tabs v-model="activeTab">
            <v-tab v-for="group in settingGroup" :key="group.name" exact :to="group.route">{{ group.name }}</v-tab>

            <v-layout text-xs-right>
              <v-flex>
                <check-permission permissions="SETTING.ADD">
                  <v-btn large color="error" @click="showAddModal">DODAJ USTAWIENIE</v-btn>
                </check-permission>
              </v-flex>
            </v-layout>
          </v-tabs>

          <div class="mt-2">
            <material-table
              editPerm="SETTING.UPDATE"
              deletePerm="SETTING.DELETE"
              :headers="headers"
              :items="list"
              :actions="true"
              :search="search"
              :total-count="count"
              @pagination="reloadList"
              @edit="showEditModal"
              @delete="showDeleteDialog"
            ></material-table>

            <material-dialog
              title="Potwierdź usunięcie"
              text="Czy napewno chcesz usunąć ustawienie?"
              :show="!!idToDelete"
              :id="idToDelete"
              @close="hideDeleteDialog"
              @confirm="remove"
            ></material-dialog>
          </div>
        </v-flex>
      </v-layout>
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="add"
      @update="updateSetting"
    ></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import Modal from './modals/Add.modal';
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import MaterialDialog from '@/components/material/Dialog';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';

// @vuese
// Wyświetlanie listy ustawień
// @group Settings
export default {
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal
  },
  mixins: [
    listMixin(
      'settings',
      {
        added: 'Dodano ustawienie.',
        addError: 'Nie udało się dodać ustawienia.',
        updated: 'Zaktualizowano ustawienie.',
        updateError: 'Nie udało się zaktualizować ustawienia.',
        deleted: 'Usunięto ustawienie.',
        deleteError: 'Nie udało się usunąć ustawienia.',
        listError: 'Nie udało się pobrać listy ustawień.'
      },
      {},
      (to, from, next) => {
        const groupId = to.params.id && parseInt(to.params.id);
        const filters = { start: 0, count: 10, desc: false, groupId, noGroup: !groupId || undefined };
        store
          .dispatch(`settings/list`, filters)
          .then(() => next())
          .catch(err =>
            store.dispatch('notifyError', {
              title: messages.listError
            })
          );
      }
    )
  ],
  data() {
    return {
      search: '',
      headers: [
        { text: 'Kod ustawienia', value: 'code' },
        { text: 'Opis ustawienia', value: 'description' }
      ],
      activeTab: this.$route.path
    };
  },
  methods: {
    filters(pagination) {
      const groupId = this.$router.currentRoute.params.id && parseInt(this.$router.currentRoute.params.id);
      return { ...pagination, groupId, noGroup: !groupId || undefined };
    },
    updateSetting(data) {
      this.update(data).then(() => this.reloadList({ count: -1 }));
    }
  },
  computed: {
    ...mapState({
      groups: state => state.settingGroups.list
    }),
    settingGroup() {
      const displayGroups = this.groups.map(group => ({
        route: `/settings/${group.id}`,
        name: group.name
      }));

      displayGroups.push({
        route: '/settings',
        name: 'Ogólne'
      });

      return displayGroups;
    }
  }
};
</script>
